const TAX_FAMILY = {
  "УСН (Доходы)": "usn_d",
  "УСН (Доходы-расходы)": "usn_dr",
  "АУСН": "ausn",
  "ОСНО": "osno",
  "ПСН": "psn",
};

export const DEFAULT_REGIME = {
  "УСН (Доходы)": "УСНд",
  "УСН (Доходы-расходы)": "УСНд-р",
  АУСН: "АУСН",
  ОСНО: "ОСНО",
  ПСН: "ПСН",
};

export function regimeFamily(code) {
  const value = String(code || "").trim();
  if (!value) return null;
  if (value === "ПСН") return "psn";
  if (value.startsWith("АУСН")) return "ausn";
  if (value.startsWith("ОСНО")) return "osno";
  if (value.startsWith("УСНд-р")) return "usn_dr";
  if (value.startsWith("УСНд") || value === "УСН 6%" || value === "УСН+ПСН") return "usn_d";
  return "other";
}

export function taxRegimeConflict(tax, regime) {
  const taxFamily = TAX_FAMILY[tax] || null;
  const family = regimeFamily(regime);
  if (!taxFamily || !family) return false;
  if (taxFamily === "psn" && (family === "psn" || String(regime).includes("ПСН"))) {
    return false;
  }
  if (
    (taxFamily === "usn_d" || taxFamily === "usn_dr")
    && String(regime).includes("ПСН")
    && family !== "psn"
  ) {
    return family !== taxFamily;
  }
  return taxFamily !== family;
}

export function taxRegimeWarning(tax, regime) {
  if (tax && !regime) {
    return "Код режима пуст — отчётность смотрит только его";
  }
  if (taxRegimeConflict(tax, regime)) {
    return "Система налогообложения и код режима не сходятся";
  }
  return "";
}

export function innOwnershipWarning(inn, ownership) {
  const digits = String(inn || "").trim();
  if (!digits || !ownership) return "";
  if (ownership === "ООО" && digits.length !== 10) {
    return "У ООО ИНН должен быть из 10 цифр";
  }
  if (ownership === "ИП" && digits.length !== 12) {
    return "У ИП ИНН должен быть из 12 цифр";
  }
  if (ownership === "ЖСК" && digits.length !== 10) {
    return "У ЖСК ИНН обычно из 10 цифр";
  }
  return "";
}
